export enum GameOrient {

    Horizontal  =1,
    Vertical  =2,

}